import { css } from "styled-components";
import isDefined from "../../../Stack/helpers/isDefined";

var getDisplay = function getDisplay(inline, force) {
  return css(["display:", ";display:", ";"], (isDefined(inline) || force) && (inline ? "inline-grid" : "grid"), (isDefined(inline) || force) && (inline ? "-ms-inline-grid" : "-ms-grid"));
};

export default getDisplay;